<button type="button" [class]="'mbm-button ' + variant() + ' mbm-button-' + size()" [class.mbm-button-icon-end]="iconPosition() === 'end'" [class.mbm-button-has-subtext]="!!subtextKey()"
  [disabled]="disabled()" (click)="onButtonClick()">
  @if (iconSrc()) {
    <img class="mbm-button-icon" [src]="iconSrc()!"
      [alt]="iconAltKey() ? (iconAltKey()! | translate) : ''"
      [attr.aria-hidden]="iconAltKey() ? null : 'true'" />
  }
  @if (subtextKey()) {
    <span class="mbm-button-text">
      <span>{{ text() ?? (textKey()! | translate) }}</span>
      <span class="mbm-button-subtext">{{ subtextKey()! | translate }}</span>
    </span>
  } @else {
    <span>{{ text() ?? (textKey()! | translate) }}</span>
  }
</button>
